import { Component, OnInit } from '@angular/core';
import { Fixtures } from '../fixtures';

@Component({
  selector: 'app-learn-structure-bottom',
  templateUrl: './learn-structure-bottom.component.html',
  styleUrls: ['./learn-structure-bottom.component.scss']
})
export class LearnStructureBottomComponent implements OnInit {

  modules: any[];

  constructor(private entities: Fixtures) { }

  ngOnInit(): void {
    this.modules = this.entities.modules;
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/learn-structure-bottom/learn-structure-bottom.component.ts